var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"predictions-carousel"},[(_vm.isLoading)?_c('div',{staticClass:"predictions-carousel--skeleton"},_vm._l((Array.from({ length: 4})),function(index){return _c('prediction-tile-skeleton',{key:index,attrs:{"is-large":false}})}),1):_vm._e(),(!_vm.isLoading && _vm.predictionList.length)?_c('carousel',{attrs:{"navigationEnabled":true,"navigation-next-label":"","navigation-prev-label":"","paginationEnabled":false,"scrollPerPage":false,"spacePadding":24,"perPageCustom":[
            [320, 1],
            [400, 1.2],
            [575, 1.25],
            [768, 0.9],
            [900, 1.25],
            [1000, 1.5],
            [1250, 2.1],
            [1600, 2.75],
            [1800, 3.2]
        ]}},_vm._l((_vm.predictionList),function(prediction){return _c('slide',{key:prediction.id},[_c('prediction-tile',{attrs:{"partnerId":_vm.partnerId,"teamId":_vm.teamId,"currencyId":_vm.currencyId,"sportEventData":prediction,"isCarouselSportEvent":true}})],1)}),1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }